import { render } from "./TestoEspandibile.vue?vue&type=template&id=13253251"
import script from "./TestoEspandibile.vue?vue&type=script&lang=js"
export * from "./TestoEspandibile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__